<div class="container-border">
  <div class="limited-offer-details-container" *transloco="let t">
    <img ngSrc="assets/images/limited-offers/limited-offers-background-image.svg" class="background-image"
         alt="background image" height="142" width="263">
    <div class="limited-offer-details-body">
      <lib-campaign-card-sentence-merchant [campaign]="campaign()"
                                           [size]="Size.SMALL"
                                           [highContrast]="true"
      ></lib-campaign-card-sentence-merchant>
    </div>

    <div class="loyalty-buttons-container">
      <div (click)="openMapApp(campaign().locationsGroup!.locations![0].address.latitude, campaign().locationsGroup!.locations![0].address.longitude)">
        {{ t('actions.card.newActionPreviewDetails.buttons.getDirections') }}
      </div>
      <div class="rewards-left">
        <img ngSrc="assets/icons/coupon-line-purple.svg" height="16" width="16" alt="coupon icon"/>
        <span class="rewards-left-text">
          {{ activeRewardsText() }}
        </span>
      </div>
    </div>
  </div>
</div>
